var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaffeeColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 5.62012C6.09 5.62012 5.75 5.28012 5.75 4.87012V3.12012C5.75 2.71012 6.09 2.37012 6.5 2.37012C6.91 2.37012 7.25 2.71012 7.25 3.12012V4.87012C7.25 5.29012 6.91 5.62012 6.5 5.62012Z",
    fill: "url(#paint0_linear_6263_73354)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.62012C10.09 5.62012 9.75 5.28012 9.75 4.87012V3.12012C9.75 2.71012 10.09 2.37012 10.5 2.37012C10.91 2.37012 11.25 2.71012 11.25 3.12012V4.87012C11.25 5.29012 10.91 5.62012 10.5 5.62012Z",
    fill: "url(#paint1_linear_6263_73354)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5.62012C14.09 5.62012 13.75 5.28012 13.75 4.87012V3.12012C13.75 2.71012 14.09 2.37012 14.5 2.37012C14.91 2.37012 15.25 2.71012 15.25 3.12012V4.87012C15.25 5.29012 14.91 5.62012 14.5 5.62012Z",
    fill: "url(#paint2_linear_6263_73354)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.7498C22.75 11.1298 20.72 9.00977 18.16 8.78977C17.42 7.57977 16.1 6.75977 14.58 6.75977H7.21C4.89 6.75977 3 8.64977 3 10.9698V11.4998H18.79V10.9698C18.79 10.7798 18.76 10.5898 18.73 10.4098C20.18 10.8398 21.25 12.1598 21.25 13.7498C21.25 15.3198 20.21 16.6298 18.79 17.0698V12.4998H3V18.2898C3 20.6098 4.89 22.4998 7.21 22.4998H14.58C16.78 22.4998 18.57 20.7998 18.75 18.6398C21.03 18.1798 22.75 16.1598 22.75 13.7498Z",
    fill: "url(#paint3_linear_6263_73354)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6263_73354",
    x1: 6.5,
    y1: 2.37012,
    x2: 6.5,
    y2: 5.62012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6263_73354",
    x1: 10.5,
    y1: 2.37012,
    x2: 10.5,
    y2: 5.62012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6263_73354",
    x1: 14.5,
    y1: 2.37012,
    x2: 14.5,
    y2: 5.62012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6263_73354",
    x1: 12.875,
    y1: 6.75977,
    x2: 12.875,
    y2: 22.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaffeeColorIcon);
export default __webpack_public_path__ + "static/media/caffee-color-icon.d6f600f48cf2ceb95398d4e0dccd8fdc.svg";
export { ForwardRef as ReactComponent };